export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  isDetailed: true,
  stickeyHeaders: true,
  detailRowComponent: 'mf-detail-row',
  fields: [
    {
      title: 'ID',
      name: 'field-generic-input',
      id: 'customId',
      prop: 'financialId',
      sortField: 'financialId',
      width: '152px',
      defaultVisible: true,
      inputProps: { type: 'text' },
    },
    {
      title: 'Name',
      name: 'field-generic-input',
      id: 'name',
      prop: 'name',
      sortField: 'name',
      width: '320px',
      sticky: true,
      alwaysVisible: true,
      inputProps: { type: 'text' },
    },
    {
      title: 'Owner',
      name: 'field-generic-input',
      id: 'owner',
      prop: 'owner.user.name',
      sortField: 'owner.user.name',
      width: '180px',
      alwaysVisible: true,
      inputProps: { type: 'text' },
    },
    {
      title: 'Company',
      name: 'field-generic-input',
      id: 'company',
      prop: 'owner.company.name',
      sortField: 'owner.company.name',
      width: '200px',
      defaultVisible: true,
      inputProps: { type: 'text' },
    },
    {
      title: 'Stage',
      name: 'field-stage',
      id: 'stage',
      prop: 'stage',
      sortField: 'stage',
      width: '140px',
      defaultVisible: true,
      inputProps: { stageColor: false },
    },
    {
      title: 'Type',
      name: 'type',
      id: 'type',
      prop: '__t',
      sortField: '__t',
      width: '140px',
      defaultVisible: true,
    },
    {
      title: 'Onsite',
      name: 'field-date',
      id: 'deliver-date',
      prop: 'date',
      sortField: 'date',
      width: '140px',
      defaultVisible: true,
      inputProps: { kind: 'deliver', min: 'coord' },
    },
  ],
};